// src/index.tsx

import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { StrictMode } from "react";
import { SubaccountProvider } from "./store/SubaccountProvider";
import { ProfileProvider } from "./store/ProfileProvider";

const theme = process.env.REACT_APP_THEME || 'default';

import(`./themes/${theme}/main.css?v=1`)
  .then(() => {

    const root = ReactDOM.createRoot(document.getElementById("root"));

    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      },
      API: {
        endpoints: [
          {
            name: process.env.REACT_APP_API_NAME,
            endpoint: process.env.REACT_APP_API_URL,
            region: process.env.REACT_APP_REGION,
          },
        ],
      },
    });

    root.render(
      <StrictMode>
        <SubaccountProvider>
          <ProfileProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ProfileProvider>
        </SubaccountProvider>
      </StrictMode>
    );
  })
  .catch((error) => {
    console.error(`Failed to load theme CSS for ${theme}:`, error);
    const root = ReactDOM.createRoot(document.getElementById("root"));

    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      },
      API: {
        endpoints: [
          {
            name: process.env.REACT_APP_API_NAME,
            endpoint: process.env.REACT_APP_API_URL,
            region: process.env.REACT_APP_REGION,
          },
        ],
      },
    });

    root.render(
      <StrictMode>
        <SubaccountProvider>
          <ProfileProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ProfileProvider>
        </SubaccountProvider>
      </StrictMode>
    );
  });